import React, { useState } from 'react'
import { Chip, Box } from '@mui/material'
import GenericButton from '../../../components/GenericButton'
import { ButtonType } from '../../../components/GenericButton/styles'
import { SlotStatus, type ISlot } from '../../../models/DistributionPlan'
import { useTheme } from '@mui/material/styles'
import { updateSlotStatusApi } from '../../../store/slices/distributionPlanSlice/apis'
import { useAppDispatch } from '../../../store'
import { getStatusLoading } from '../../../store/slices/distributionPlanSlice/selectors'
import PageHeader from '../../../components/PageHeader'
import { type CustomBreadcrumbT } from '../../../utils/BreadcrumbDataPreparation'
import GenericModal from '../../../components/GenericModal'
import DistributionPlanDetails from '../DistributionPlanDetails'
import { CreateAndEditDistributionPlan } from '../../DistributionSeriesAndPlan/DistributionPlan/CreateAndEditDistributionPlan'
import { SurveyProjectButtons } from './styles'

interface CourseEvaluationHeaderProps {
  slot: ISlot | undefined
  breadcrumb: CustomBreadcrumbT[]
}

const CourseEvaluationHeader: React.FC<CourseEvaluationHeaderProps> = ({ slot, breadcrumb }) => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const params = new URLSearchParams(window.location.search)
  const isNavigatePresent = params.has('navigate')
  const statusLoading = getStatusLoading()
  const status = slot?.slotNodeDetails?.slotStatus ?? 'default'
  const buttonTitle = status === SlotStatus.Draft ? 'Publish' : 'Revert to draft'
  const buttonType = status === SlotStatus.Draft ? ButtonType.Tertiary : ButtonType.Secondary
  const isPublishButtonShow = status === SlotStatus.Draft || status === SlotStatus.Published
  const chipVariant = status === SlotStatus.Draft ? 'outlined' : 'filled'

  const chipColors: Record<string, string> = {
    Draft: 'default',
    Published: 'primary',
    Live: 'success'
  }

  const chipColor: any = chipColors[status]
  const [openModal, setOpenModal] = useState<boolean>(false)

  const handleUpdateSlotStatus = (): void => {
    const updateStatus = status === SlotStatus.Draft ? SlotStatus.Published : SlotStatus.Draft
    void dispatch(updateSlotStatusApi({ urlId: slot?.slotId, data: { status: updateStatus } }))
  }
  const handleCloseModal = (): void => {
    setOpenModal(false)
  }
  const publishButton = isPublishButtonShow && (
    <GenericButton
      label={buttonTitle}
      buttonType={buttonType}
      onClick={handleUpdateSlotStatus}
      style={{
        flexShrink: 0,
        [theme.breakpoints.down('md')]: {
          width: '100%'
        }
      }}
    />
  )

  const isShowEditButton = slot?.slotNodeDetails.slotStatus !== SlotStatus.Closed

  return (
    <React.Fragment>
      <PageHeader
        title={slot?.title ?? ''}
        breadcrumb={breadcrumb}
        controls={
          !isNavigatePresent &&
          <SurveyProjectButtons>
            {isShowEditButton && (
              <GenericButton label="Edit" variant="text" onClick={() => { setOpenModal(true) }} />
            )}
            {isPublishButtonShow && publishButton}
          </SurveyProjectButtons>
        }
        statusChip={
          <React.Fragment>
            <Chip size="small" label={status} variant={chipVariant} color={chipColor} />
          </React.Fragment>
        }
        attributes=
        {slot && <DistributionPlanDetails slot={slot} />}

      />
      <GenericModal
        isOpen={openModal}
        maxWidth="sm"
        title={`Edit ${slot?.term?.termName} Survey Project`}
        onClose={() => { setOpenModal(false) }}
        action={false}
      >
        <CreateAndEditDistributionPlan selectedRow={slot} handleCloseModal={handleCloseModal} />
      </GenericModal>

    </React.Fragment>
  )
}

export default CourseEvaluationHeader
